export const receiptTypeEnum = {
  NONE: 0,
  CARRIER: 1,
  LOVE: 2,
  IDENTIFIER: 3,
};

export const receiptMethodCodeEnum: Record<"ECPAY" | "AMEGO", string> = {
  ECPAY: "ECPAY",
  AMEGO: "AMEGO",
};

export const carrierTypeEnum = {
  //載具類別 無載具：0, 1：綠界電子發票載具, 2：自然人憑證, 3：手機條碼, 4：悠遊卡, 5：一卡通
  NONE: 0,
  ECPAY: 1,
  NATURE: 2,
  MOBILE: 3,
  UPASS: 4,
  ONE_CARD: 5,
};
